import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis, Slot } from '../Iconen.jsx';

export default function Pin({ v }) {
  if (!v.showPin) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "99", "padding": "20px" }} onClick={v.closePin}>
        <div className="gp-venster" style={{ "width": "min(400px,100%)", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "16px" }} onClick={v.stopProp}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "8px" }}>
            <Slot maat={22} />
            <div style={{ "fontSize": "19px", "fontWeight": "700", "flex": "1 1 auto" }}>
              <Interp v={v.pinTitle} />
            </div>
            <button onClick={v.closePin} title="Sluiten" style={css(v.sluitStyle)}>
              <Kruis maat={20} />
            </button>
          </div>
          <div style={{ "fontSize": "13px", "fontWeight": "600", "color": "var(--tekst-2)", "lineHeight": "1.4" }}>
            <Interp v={v.pinSubtitle} />
          </div>
          <div style={{ "display": "flex", "gap": "8px", "justifyContent": "center", "padding": "2px 0" }}>
            {toList(v.pinBoxes).map((b, $index) => (
              <React.Fragment key={$index}>
                <div style={{ "position": "relative", "width": "54px", "height": "62px", "flex": "0 0 auto", "border": "3px solid var(--ink)", "borderRadius": "12px", "background": "#fff", "display": "flex", "alignItems": "center", "justifyContent": "center" }}>
                  {b?.filled ? (<>
                    <span style={{ "width": "15px", "height": "15px", "borderRadius": "999px", "background": "var(--ink)", "display": "block" }} />
                  </>) : null}
                  <input type="text" inputMode="numeric" autoComplete="off" maxLength="2" value={b?.value ?? ''} ref={b?.ref} onInput={b?.onInput} onKeyDown={b?.onKeyDown} onFocus={b?.onFocus} style={{ "position": "absolute", "inset": "0", "width": "100%", "height": "100%", "border": "none", "borderRadius": "12px", "background": "transparent", "color": "transparent", "caretColor": "var(--ink)", "textAlign": "center", "fontSize": "28px", "padding": "0", "boxShadow": "none" }} />
                </div>
              </React.Fragment>
            ))}
          </div>
          {v.hasPinError ? (<>
            <div style={{ "fontSize": "13px", "fontWeight": "600", "color": "var(--fout)" }}>
              <Interp v={v.pinError} />
            </div>
          </>) : null}
          <button onClick={v.submitPin} className="gp-btn pink" disabled={v.pinBusy} style={css(v.hoofdKnopStyle)}>
            <Interp v={v.pinBtnLabel} />
          </button>
        </div>
      </div>
      {' '}
    </>
  );
}
